export default "__VITE_ASSET__fb77f0f4__"